import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonMode } from '@components/atoms/Button';
import { Typography } from '@components/atoms/Typography';
import { useGetSuggestionQuestions } from '@services/useGetSuggestionQuestions';
import { SuggestChangesModal, SuggestChangesModalProps } from './_subcomponents/SuggestChangesModal/SuggestChangesModal';

export interface SuggestChangesProps {
    type: SuggestChangesModalProps['type'];
    dataForSelects: SuggestChangesModalProps['dataForSelects'];
}

export const SuggestChanges: FC<SuggestChangesProps> = ({ type, dataForSelects }) => {
    const { request: requestSuggestionQuestions } = useGetSuggestionQuestions();
    const { t } = useTranslation();

    const translations = {
        suggest: t('suggest-changes-component.suggest'),
    };

    const [showModal, setShowModal] = useState<boolean>(false);

    const handleOnClickSuggest = () => {
        requestSuggestionQuestions();
        setShowModal(true);
    };

    return (
        <>
            <Button
                label={<Typography color="primary">{translations.suggest}</Typography>}
                mode={ButtonMode.none}
                size="sm"
                classes="d-inline-block m-0 p-0"
                onClick={handleOnClickSuggest}
            />
            <SuggestChangesModal
                type={type}
                dataForSelects={dataForSelects}
                show={showModal}
                onClose={() => setShowModal(false)}
            />
        </>
    );
};
